import { Expose } from "class-transformer";

export class CreateBankDto {
  @Expose()
  name: string;
}
